import { EditOutlined, ReloadOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Table,
  Tooltip,
  TreeSelect
} from "antd";
import { RANGE_PICKER_RANGES } from "app/modules/camera/_redux/constants";
import { DATE_FORMAT } from "app/ultils/constant";
import { get, includes, join, map, pullAll, size, toLower } from "lodash";
import dayjs from "dayjs";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import services from "services";
import {
  convertRegionProvinceStation,
  removeVietnameseTones
} from "../../../../../lib/admin";
import {
  SCALE_CAMERA_STATUS,
  SCALE_STATUS,
  SCALE_V2_CAMERA_STATUS
} from "../../_redux/constants";
import SmartScaleBBSModal from "../../components/bbs-manage/SmartScaleBBSModal";

const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const { TreeNode } = TreeSelect;

const CAMERA_TYPE = {
  dahua: "Dahua",
  hiview: "Hiview"
};

const CARD_STYLE = {
  borderRadius: "0.42rem",
  boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
};

let searchTimer = null;

const Password = ({ password }) => {
  const [visible, setVisible] = useState({
    value: false
  });

  const _handleShowPass = () => {
    setVisible(prev => ({
      ...prev,
      value: !visible.value
    }));
  };

  return !password ? (
    ""
  ) : (
    <Tooltip placement="topLeft" title={"Hiển thị mật khẩu"}>
      <b onClick={_handleShowPass} style={{ cursor: "default" }}>
        {visible.value ? password : "**********"}
      </b>
    </Tooltip>
  );
};

const SmartScaleBBSManagePage = () => {
  const _ = require("lodash");
  const [form] = Form.useForm();
  const [isFetching, setIsFetching] = useState(false);
  const [scaleModalConfig, setScaleModalConfig] = useState({
    visible: false,
    isCreate: true,
    dataSource: {}
  });
  const [tableConfig, setTableConfig] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true
    },
    sorter: {}
  });
  const [tableData, setTableData] = useState({
    dataSource: [],
    total: 0
  });

  const range = (r, max) => {
    if (!max % r) return [];
    const n = max / r;
    let arrRemove = [];
    for (let i = 0; i < n; i++) {
      arrRemove = [...arrRemove, i * r];
    }
    let rangeResult = range(max);
    return pullAll(rangeResult, arrRemove);
  };

  const disabledDate = current => {
    return current && current > dayjs().endOf("day");
  };

  const disabledRangeTime = () => {
    return {
      disabledMinutes: () => range(5, 60)
    };
  };

  const stationTreeData = useSelector(x => x.app.listStationsV2);

  const searchSmartScale = React.useCallback(async params => {
    setIsFetching(true);
    let res = await services.SmartScaleService.getSmartScaleV2(params);
    setIsFetching(false);
    const isSuccess = get(res, "data.success");
    let data = [];
    if (isSuccess) {
      data = get(res, "data.data", []);
    }
    let total = get(res, "data.total_elements", 0);
    setTableData(prev => {
      let next = { ...prev };
      next.dataSource = data;
      next.total = total;
      return next;
    });
  }, []);

  const onChangeTable = pagination => {
    setTableConfig(prev => ({ ...prev, pagination }));
  };

  let getIndex = index =>
    (tableConfig.pagination.current - 1) * tableConfig.pagination.pageSize +
    index +
    1;

  let rowKey = record => `
      ${record.id}`;

  let columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "stt",
      align: "center",
      width: 20,
      render: (_, __, index) => getIndex(index)
    },
    {
      title: "Kho",
      dataIndex: "station_name",
      align: "center"
    },
    {
      title: "Thông tin cân",
      align: "center",
      children: [
        {
          title: "Tên thiết bị",
          dataIndex: "scale_name",
          key: "scale_name",
          align: "center"
        },
        {
          title: "MAC cân",
          dataIndex: "mac",
          align: "center"
        },
        {
          title: "Đợt cân",
          dataIndex: "version",
          align: "center"
        },
        {
          title: "Mở / Khoá",
          dataIndex: "lock",
          align: "center",
          render: value => {
            return value ? "Đang khoá" : "Đang mở";
          }
        },
        {
          title: "Trạng thái cân",
          dataIndex: "status",
          key: "status",
          align: "center",
          render: (value, record) => {
            const today = dayjs();
            const last_date = dayjs(record.last_use_date, "DD/MM/YYYY");
            const days_unused = today.diff(last_date, "days");
            if (value) {
              return (
                <div className="d-flex align-items-center flex-column">
                  <span
                    style={{
                      width: 16,
                      height: 16,
                      backgroundColor: SCALE_STATUS[value]?.color,
                      borderRadius: "100%"
                    }}
                  />
                  <span style={{ fontSize: 13 }}>
                    {SCALE_STATUS[value]?.label}
                  </span>
                  {value == "NOT_USING" &&
                    record.last_use_date && (
                      <span
                        style={{ fontSize: 13 }}
                      >{`(${days_unused} ngày)`}</span>
                    )}
                </div>
              );
            }
          }
        }
      ]
    },
    {
      title: "Thông tin controller",
      align: "center",
      children: [
        {
          title: "MAC controller",
          dataIndex: "mac_controller",
          align: "center"
        },
        {
          title: "Version",
          dataIndex: ["controller_info", "version"],
          align: "center"
        },
        {
          title: "Lần cuối online",
          dataIndex: ["controller_info", "last_active_date"],
          align: "center",
          render: value => {
            return value ? value : "";
          }
        },
        {
          title: "Trạng thái",
          dataIndex: ["controller_info", "status"],
          align: "center",
          render: value => {
            return (
              <div className="d-flex align-items-center flex-column">
                <span
                  style={{
                    width: 16,
                    height: 16,
                    backgroundColor: SCALE_V2_CAMERA_STATUS[value]?.color,
                    borderRadius: "100%"
                  }}
                />
                <span style={{ fontSize: 13 }}>
                  {SCALE_V2_CAMERA_STATUS[value]?.label}
                </span>
              </div>
            );
          }
        }
      ]
    },
    {
      title: "Thông tin cam",
      align: "center",
      children: [
        {
          title: "Tên cam",
          dataIndex: ["bbs_camera_info", "camera_name"],
          key: "camera_name",
          align: "center"
        },
        {
          title: "Offset",
          dataIndex: "camera_offset",
          key: "camera_offset",
          align: "center"
        },
        {
          title: "Trạng thái",
          dataIndex: ["bbs_camera_info", "status"],
          key: "status",
          align: "center",
          render: value => {
            const status = value || 0;
            return (
              <div className="d-flex align-items-center flex-column">
                <span
                  style={{
                    width: 16,
                    height: 16,
                    backgroundColor: SCALE_CAMERA_STATUS[status]?.color,
                    borderRadius: "100%"
                  }}
                />
                <span style={{ fontSize: 13 }}>
                  {SCALE_CAMERA_STATUS[status]?.label}
                </span>
              </div>
            );
          }
        },
        {
          title: "Lần cuối online",
          dataIndex: ["bbs_camera_info", "last_online_date"],
          key: "last_online_date",
          align: "center",
          render: value => {
            return (
              <div>{value ? <span>{dayjs(value).fromNow()}</span> : "-"}</div>
            );
          }
        },
        {
          title: "SN",
          dataIndex: ["bbs_camera_info", "camera_sn"],
          key: "camera_sn",
          align: "center"
        },
        {
          title: "MAC",
          dataIndex: ["bbs_camera_info", "camera_mac"],
          key: "camera_sn",
          align: "center"
        },
        {
          title: "Kiểu kết nối",
          dataIndex: ["bbs_camera_info", "connect_type"],
          key: "connect_type",
          align: "center",
          render: value => {
            return (
              <div>
                {value === 1 && <span>Public</span>}
                {value === 0 && <span>Local</span>}
              </div>
            );
          }
        },
        {
          title: "IP Camera",
          dataIndex: "bbs_camera_info",
          key: "ip",
          align: "center",
          render: value => {
            if (value?.connect_type === 0) {
              return value?.local_ip;
            }
            return value?.public_ip;
          }
        },
        {
          title: "TCP Port",
          dataIndex: "bbs_camera_info",
          key: "tcp_port",
          align: "center",
          render: value => {
            if (value?.connect_type === 0) {
              return value?.local_tcp_port;
            }
            return value?.public_tcp_port;
          }
        },
        {
          title: "HTTP Port",
          dataIndex: "bbs_camera_info",
          key: "http_port",
          align: "center",
          render: value => {
            if (value?.connect_type === 0) {
              return value?.local_http_port;
            }
            return value?.public_http_port;
          }
        },
        {
          title: "RTSP Port",
          dataIndex: "bbs_camera_info",
          key: "rtsp_port",
          align: "center",
          render: value => {
            if (value?.connect_type === 0) {
              return value?.local_rtsp_port;
            }
            return value?.public_rtsp_port;
          }
        },
        {
          title: "Tên đăng nhập",
          dataIndex: ["bbs_camera_info", "user"],
          key: "user",
          align: "center"
        },
        {
          title: "Mật khẩu",
          dataIndex: ["bbs_camera_info", "password"],
          key: "password",
          align: "center",
          render: password => <Password password={password} />
        }
      ]
    },
    {
      title: "Sử dụng gần nhất",
      children: [
        {
          title: "Thời gian",
          dataIndex: "last_use_date",
          align: "center"
        },
        {
          title: "Username",
          dataIndex: "last_use_username",
          align: "center"
        },
        {
          title: "Số điện thoại",
          dataIndex: "last_use_tel",
          align: "center"
        },
        {
          title: "Màn hình",
          dataIndex: "current_screen_id",
          align: "center"
        },
        {
          title: "Số ngày sử dụng",
          dataIndex: "total_use_day",
          align: "center"
        }
      ]
    },
    {
      title: "Thông tin đơn hàng",
      children: [
        {
          title: "Số đơn hàng đã cân",
          dataIndex: "total_pck_weighed",
          align: "center"
        },
        {
          title: "Khối lượng đã cân (Kg)",
          dataIndex: "total_pck_mass",
          align: "center",
          render: value => {
            return value ? _.round(value) : "";
          }
        }
      ]
    },

    {
      title: "Lịch sử sửa chữa",
      children: [
        {
          title: "Ngày sửa gần nhất",
          dataIndex: "repair_logs",
          key: "last_repair_date",
          align: "center",
          render: value => {
            let data = value?.[0] || undefined;
            return data && data?.repair_date
              ? dayjs(data?.repair_date).format("DD-MM-YYYY")
              : "";
          }
        },
        {
          title: "Số lần sửa",
          dataIndex: "repair_logs",
          key: "total_repair_times",
          align: "center",
          render: value => {
            return value?.length || 0;
          }
        }
      ]
    },
    {
      key: "action",
      dataIndex: "action",
      title: "Hành động",
      fixed: "right",
      align: "center",
      render: (_, item) => {
        const openModal = () => {
          setScaleModalConfig(prev => {
            let next = { ...prev };
            next.isCreate = false;
            next.visible = true;
            next.dataSource = item;
            return next;
          });
        };

        return (
          <div className="d-flex align-items-center justify-content-center">
            <EditOutlined onClick={openModal} className="text-primary mr-2" />
          </div>
        );
      }
    }
  ];

  const onShowScaleModal = (isShow, isCreate = true) => {
    if (isShow === false) {
      setTableConfig(prev => ({
        ...prev,
        pagination: { ...prev.pagination, current: 1 }
      }));
    }
    setScaleModalConfig(prev => ({
      ...prev,
      isCreate,
      visible: isShow,
      dataSource: undefined
    }));
  };

  const onValuesChange = () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(async () => {
      setTableConfig(prev => ({
        ...prev,
        pagination: { ...prev.pagination, current: 1 }
      }));
    }, 500);
  };

  useEffect(
    () => {
      const result = convertRegionProvinceStation(
        form.getFieldValue("station") || []
      );
      let date = form.getFieldValue("fromTo");
      let fromDate = date?.[0];
      let endDate = date?.[1];
      fromDate = size(date) ? dayjs(fromDate).format("DD-MM-YYYY") : undefined;
      endDate = size(date) ? dayjs(endDate).format("DD-MM-YYYY") : undefined;
      let params = {
        page: tableConfig.pagination.current - 1,
        size: tableConfig.pagination.pageSize,
        from_day: fromDate,
        end_day: endDate,
        mac: form.getFieldValue("mac")?.trim() || undefined,
        mac_controller:
          form.getFieldValue("mac_controller")?.trim() || undefined,
        name: form.getFieldValue("scale_name")?.trim() || undefined,
        status: form.getFieldValue("scale_status") || undefined,
        lock: form.getFieldValue("lock"),
        camera_status: form.getFieldValue("camera_status") || undefined,
        controller_status: form.getFieldValue("controller_status") || undefined,
        scale_options: ["BBSS", "BBSB"]?.toString() || undefined,
        province_ids:
          size(result.province_id) > 0
            ? join(result.province_id, ",")
            : undefined,
        region_ids:
          size(result.region_id) > 0 ? join(result.region_id, ",") : undefined,
        station_ids:
          size(result.station_id) > 0 ? join(result.station_id, ",") : undefined
      };
      searchSmartScale(params).then(r => r);
    },
    [searchSmartScale, tableConfig, form]
  );

  const [cameraType, setCameraType] = useState([]);

  const fetchScaleFilters = useCallback(async () => {
    let res = await services.SmartScaleService.getScaleFilter();
    const isSuccess = get(res, "data.success");
    if (isSuccess) {
      let scaleCameraTypes = get(res, "data.data.scale_camera_types", []);
      setCameraType(scaleCameraTypes);
    }
  }, []);

  useEffect(
    () => {
      fetchScaleFilters();
    },
    [fetchScaleFilters]
  );

  return (
    <Row gutter={[8, 8]} className="smartlock-mange__page">
      <Col span={24}>
        <Card style={CARD_STYLE} size="small">
          <Form form={form} layout="vertical" onValuesChange={onValuesChange}>
            <Row gutter={[8, 8]} align="bottom">
              <Col xl={4} xs={8}>
                <Form.Item name="station" label="Kho" className="mb-0">
                  <TreeSelect
                    allowClear
                    multiple
                    treeCheckable={true}
                    showCheckedStrategy={SHOW_PARENT}
                    style={{ width: "100%" }}
                    filterTreeNode={(input, treeNode) => {
                      return includes(
                        toLower(removeVietnameseTones(get(treeNode, "title"))),
                        toLower(removeVietnameseTones(input))
                      );
                    }}
                    dropdownStyle={{
                      maxHeight: 400,
                      overflow: "auto",
                      overflowX: "hidden"
                    }}
                    placeholder="Chọn kho"
                    onChange={station => {
                      form.setFieldsValue({ station });
                    }}
                  >
                    {map(stationTreeData, station => {
                      return (
                        <TreeNode
                          value={station.region_name}
                          title={station.region_name}
                          key={station.region_name}
                          selectable={false}
                        >
                          {map(station.provinces, province => {
                            return (
                              <TreeNode
                                value={province.province_name}
                                title={province.province_name}
                                key={province.province_name}
                                selectable={false}
                              >
                                {map(province.stations, nestStation => {
                                  return (
                                    <TreeNode
                                      value={nestStation.station_id}
                                      title={nestStation.station_name}
                                      key={nestStation.station_id}
                                    />
                                  );
                                })}
                              </TreeNode>
                            );
                          })}
                        </TreeNode>
                      );
                    })}
                  </TreeSelect>
                </Form.Item>
              </Col>

              <Col xl={4} xs={8}>
                <Form.Item
                  name="fromTo"
                  label="Thời gian sử dụng gần nhất"
                  className="mb-0"
                >
                  <DatePicker.RangePicker
                    showTime={false}
                    disabledDate={disabledDate}
                    disabledTime={disabledRangeTime}
                    format={DATE_FORMAT}
                    style={{ width: "100%" }}
                    presets={RANGE_PICKER_RANGES}
                  />
                </Form.Item>
              </Col>

              <Col xl={4} xs={8}>
                <Form.Item
                  name="scale_name"
                  label="Tên thiết bị"
                  className="mb-0"
                >
                  <Input placeholder="Nhập tên thiết bị" allowClear />
                </Form.Item>
              </Col>

              <Col xl={4} xs={8}>
                <Form.Item name="mac" label="MAC cân" className="mb-0">
                  <Input placeholder="Địa chỉ MAC cân" allowClear />
                </Form.Item>
              </Col>

              <Col xl={4} xs={8}>
                <Form.Item
                  name="mac_controller"
                  label="MAC controller"
                  className="mb-0"
                >
                  <Input placeholder="Địa chỉ MAC controller" allowClear />
                </Form.Item>
              </Col>

              <Col xl={4} xs={8}>
                <Form.Item name="lock" label="Mở / Khoá" className="mb-0">
                  <Select
                    allowClear
                    size="default"
                    placeholder="Chọn Mở / Khoá"
                    style={{ width: "100%" }}
                    options={[
                      { value: false, label: "Mở" },
                      { value: true, label: "Khoá" }
                    ]}
                  />
                </Form.Item>
              </Col>

              <Col xl={4} xs={8}>
                <Form.Item
                  name="scale_status"
                  label="Trạng thái cân"
                  className="mb-0"
                >
                  <Select
                    allowClear
                    size="default"
                    placeholder="Chọn trạng thái cân"
                    style={{ width: "100%" }}
                  >
                    {map(SCALE_STATUS, scaleStatus => (
                      <Select.Option
                        key={scaleStatus.value}
                        value={scaleStatus.value}
                      >
                        {scaleStatus.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xl={4} xs={8}>
                <Form.Item
                  name="controller_status"
                  label="Trạng thái controller"
                  className="mb-0"
                >
                  <Select
                    allowClear
                    size="default"
                    placeholder="Chọn trạng thái controller"
                    style={{ width: "100%" }}
                  >
                    <Select.Option
                      key={`scale_controller_st_1`}
                      value={"ONLINE"}
                    >
                      Online
                    </Select.Option>
                    <Select.Option
                      key={`scale_controller_st_1`}
                      value={"DISCONNECT"}
                    >
                      Disconnect
                    </Select.Option>
                    <Select.Option
                      key={`scale_controller_st_0`}
                      value={"OFFLINE"}
                    >
                      Offline
                    </Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xl={4} xs={8}>
                <Form.Item
                  name="camera_status"
                  label="Trạng thái camera"
                  className="mb-0"
                >
                  <Select
                    allowClear
                    size="default"
                    placeholder="Chọn trạng thái camera"
                    style={{ width: "100%" }}
                  >
                    <Select.Option key={`scale_camera_st_0`} value={"1"}>
                      Online
                    </Select.Option>
                    <Select.Option key={`scale_camera_st_1`} value={"0"}>
                      Offline
                    </Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      </Col>

      <Col span={24}>
        <Card style={CARD_STYLE} size="small">
          <Row gutter={[8, 8]} align="bottom" justify="end">
            <Col>
              <div className="d-flex">
                <Button
                  className="mr-2 mb-0"
                  onClick={() =>
                    setTableConfig(prev => ({
                      ...prev,
                      pagination: { ...prev.pagination }
                    }))
                  }
                  icon={<ReloadOutlined />}
                >
                  Làm mới
                </Button>
              </div>
            </Col>

            <Col span={24}>
              <Table
                size="small"
                columns={columns}
                loading={isFetching}
                bordered
                dataSource={tableData.dataSource}
                rowKey={rowKey}
                pagination={{
                  ...tableConfig.pagination,
                  total: tableData.total
                }}
                onChange={onChangeTable}
                scroll={{
                  x: "max-content"
                }}
              />
            </Col>
          </Row>
        </Card>
      </Col>
      <SmartScaleBBSModal
        config={scaleModalConfig}
        onShowModal={onShowScaleModal}
        cameraType={cameraType}
        cameraTypeAlias={CAMERA_TYPE}
      />
    </Row>
  );
};

export default SmartScaleBBSManagePage;
